import { useState } from "react";
import { Card, Form, Input, Button, Alert, Typography, Space } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { SIGNUP_ENABLED } from "@/lib/features";

const { Title, Text } = Typography;

interface LoginForm {
  email: string;
  password: string;
}

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const login = useAuthStore((s) => s.login);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Redirect đến trang user đang xem trước khi bị đẩy về login.
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? "/";

  const handleSubmit = async (values: LoginForm) => {
    setLoading(true);
    setError(null);
    try {
      await login(values.email, values.password);
      navigate(from, { replace: true });
    } catch (err: unknown) {
      const detail =
        (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail;
      setError(detail ?? "Đăng nhập thất bại. Vui lòng thử lại.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f5f7",
      }}
    >
      <Card style={{ width: 420, padding: "16px 8px" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div style={{ textAlign: "center" }}>
            <Title level={2} style={{ margin: 0 }}>
              E-learning 2026
            </Title>
            <Text type="secondary">AI-native EdTech</Text>
          </div>

          {error && <Alert type="error" message={error} showIcon closable />}

          <Form<LoginForm>
            layout="vertical"
            onFinish={handleSubmit}
            requiredMark={false}
          >
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Vui lòng nhập email." },
                { type: "email", message: "Email không hợp lệ." },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="alice@savina.vn"
                size="large"
                autoComplete="email"
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="Mật khẩu"
              rules={[{ required: true, message: "Vui lòng nhập mật khẩu." }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="••••••••"
                size="large"
                autoComplete="current-password"
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
              >
                Đăng nhập
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: "center" }}>
            <Space split={<Text type="secondary">·</Text>}>
              <Link to="/forget-password">Quên mật khẩu?</Link>
              {SIGNUP_ENABLED && <Link to="/signup">Tạo tài khoản mới</Link>}
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
}

export default Login;
